import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Card, Grid, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import TopicFootprintSmall from "~/components/TopicFootprintSmall";
const StyledGrid = styled(Grid)`
  overflow: hidden;
  position: relative;
`;
const Scrollable = styled.div`
  overflow: auto;
  max-height: 600px;
`;
const TopicSummaryFootprintsCard = _ref => {
  let {
    footprints,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Card, _extends({
    s: {
      p: 0
    },
    fullWidth: true
  }, rest), footprints.length ? /*#__PURE__*/React.createElement(Scrollable, null, /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 1,
    template: "1fr",
    gap: 3,
    fullWidth: true,
    s: {
      ml: -2,
      pt: 2
    }
  }, footprints.map(footprint => /*#__PURE__*/React.createElement(TopicFootprintSmall, {
    key: footprint.id,
    footprint: footprint
  })))) : /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 4,
    weight: "semiBold",
    s: {
      mt: 5
    },
    display: "block"
  }, t("TrendOverviewFootprintsCard.noFootprintsFound")));
};
export default TopicSummaryFootprintsCard;